var _g, _g2, _path, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 982,
    viewBox: "0 0 1440 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_33161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 982,
    fill: "#C9E6FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2200_33161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.001 112.362C171.001 84.9669 148.734 62.7566 121.294 62.7566C111.382 62.7566 102.146 65.6987 94.3855 70.6906C85.6095 41.3904 58.4351 20 26.2079 20C-13.103 20 -44.9676 51.7841 -44.9676 90.9716C-44.9676 91.3333 -44.9192 91.6951 -44.9192 92.0568C-44.9192 92.0568 -44.9434 92.0568 -44.9676 92.0568C-64.3329 92.0568 -80.0234 107.708 -80.0234 127H168.801C170.227 122.37 171.001 117.45 171.001 112.362Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2200_33161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1384 173.264C1384 143.848 1360.14 119.955 1330.73 119.955C1320.11 119.955 1310.22 123.102 1301.9 128.497C1292.49 96.9936 1263.37 74 1228.82 74C1186.7 74 1152.57 108.137 1152.57 150.271C1152.57 150.656 1152.63 151.041 1152.63 151.427C1152.63 151.427 1152.6 151.427 1152.57 151.427C1131.82 151.427 1115 168.254 1115 189H1381.66C1383.2 184.022 1384.03 178.756 1384.03 173.264H1384Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2200_33161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.279 490.592C752.939 461.777 746.804 444.059 740.923 437.455C736.929 433.073 731.523 431.406 724.691 432.454C720.808 433.041 717.716 434.279 715.418 436.153L692.053 455.125C694.351 453.251 697.442 452.013 701.326 451.426C708.158 450.378 713.563 452.045 717.558 456.427C723.455 463.031 729.574 480.749 735.914 509.564C742.429 539.189 744.236 557.463 741.32 564.369C740.479 566.607 739.164 568.465 737.373 569.91L760.738 550.938C762.529 549.477 763.845 547.635 764.685 545.397C767.602 538.491 765.81 520.233 759.279 490.592Z",
    fill: "url(#paint0_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.293 598.741C739.038 602.154 721.014 598.677 707.223 588.279C698.981 582.055 691.721 572.64 685.412 560.051C679.118 547.477 673.285 528.997 667.911 504.611C658.765 463.079 658.717 433.517 667.753 415.863C670.162 411.132 673.602 406.941 678.072 403.321L654.707 422.293C650.253 425.913 646.813 430.104 644.388 434.835C635.352 452.473 635.4 482.051 644.546 523.583C649.92 547.969 655.737 566.449 662.046 579.023C668.355 591.613 675.615 601.011 683.858 607.251C697.649 617.65 715.672 621.126 737.928 617.713C753.13 615.379 765.082 610.696 773.784 603.615L797.15 584.643C788.447 591.708 776.495 596.407 761.293 598.741Z",
    fill: "url(#paint1_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.836 400.05C786.798 413.863 799.337 441.519 808.483 483.051C813.857 507.437 816.267 526.457 815.728 540.062C815.189 553.7 812.415 564.655 807.374 572.91C799.099 586.691 783.739 595.296 761.293 598.725C739.038 602.138 721.014 598.662 707.223 588.263C698.98 582.039 691.72 572.625 685.412 560.035C679.118 547.461 673.285 528.981 667.911 504.595C658.765 463.063 658.717 433.501 667.753 415.847C671.557 408.401 677.882 402.321 686.743 397.621C695.588 392.938 705.004 389.81 714.959 388.286C738.578 384.666 757.203 388.588 770.82 400.034L770.836 400.05ZM764.685 545.381C767.602 538.475 765.811 520.217 759.28 490.576C752.939 461.761 746.805 444.043 740.924 437.439C736.929 433.057 731.524 431.39 724.692 432.438C717.654 433.517 713.215 436.692 711.345 441.979C708.713 449.266 710.647 467.619 717.115 497.054C723.63 526.679 729.733 544.286 735.392 549.874C739.545 554.034 744.934 555.605 751.576 554.589C758.408 553.541 762.783 550.477 764.685 545.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.772 456.252L535.06 470.588L495.907 529.044L450.635 514.692L489.772 456.252Z",
    fill: "url(#paint2_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.945 559.495L512.234 573.847L448.288 562.924L403 548.572L466.945 559.495Z",
    fill: "url(#paint3_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.188 397.351L591.46 411.703L562.991 540.491L517.719 526.155L546.188 397.351Z",
    fill: "url(#paint4_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.694 603.123L545.982 617.475L504.165 610.331L458.877 595.994L500.694 603.123Z",
    fill: "url(#paint5_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.762 566.623L554.05 580.975L545.981 617.475L500.693 603.123L508.762 566.623Z",
    fill: "url(#paint6_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.946 569.386L570.218 583.738L554.05 580.975L508.762 566.623L524.946 569.386Z",
    fill: "url(#paint7_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.888 528.901L579.176 543.254L570.219 583.738L524.947 569.386L533.888 528.901Z",
    fill: "url(#paint8_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.718 526.155L533.903 528.917L524.947 569.402L508.762 566.639L500.694 603.139L458.877 595.994L466.945 559.495L403 548.572L410.53 514.534L493.18 388.302L546.188 397.351L517.718 526.139V526.155ZM475.917 519.011L489.788 456.236L450.634 514.692L475.902 519.011",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.83 548.747L984.881 510.692L1003.05 508.135L1038 546.191L1019.83 548.747Z",
    fill: "url(#paint9_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.752 624L928.783 585.945L933.095 553.399L968.064 591.454L963.752 624Z",
    fill: "url(#paint10_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.428 559.352L909.459 521.297L937.881 517.296L972.834 555.351L944.428 559.352Z",
    fill: "url(#paint11_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.834 555.351L937.881 517.296L945.299 461.332L980.252 499.404L972.834 555.351Z",
    fill: "url(#paint12_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.16 601.567L861.207 563.512L865.217 533.172L900.186 571.228L896.16 601.567Z",
    fill: "url(#paint13_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.465 442.297L940.512 404.242L1000.08 395.859L1035.05 433.914L975.465 442.297Z",
    fill: "url(#paint14_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.185 571.228L865.217 533.172L940.512 404.242L975.465 442.297L900.185 571.228Z",
    fill: "url(#paint15_linear_2200_33161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.83 548.747L1038 546.191L1033.21 582.277L1015.05 584.833L1010.74 617.38L963.736 624L968.047 591.454L896.16 601.567L900.186 571.227L975.482 442.297L1035.05 433.914L1019.83 548.747ZM972.834 555.367L980.253 499.404L944.428 559.368L972.85 555.367",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2200_33161)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 511.318V982H0V515.215C8.02092 518.111 17.1877 520.569 32.7384 520.569C70.6241 520.569 70.6241 506 108.528 506C146.432 506 146.414 520.569 184.317 520.569C222.221 520.569 222.221 506 260.107 506C297.992 506 297.992 520.569 335.896 520.569C373.8 520.569 373.782 506 411.668 506C449.553 506 449.553 520.569 487.457 520.569C525.361 520.569 525.343 506 563.228 506C601.114 506 601.114 520.569 639.018 520.569C676.922 520.569 676.904 506 714.789 506C752.675 506 752.675 520.569 790.579 520.569C828.482 520.569 828.464 506 866.35 506C904.236 506 904.254 520.569 942.139 520.569C980.025 520.569 980.025 506 1017.93 506C1055.83 506 1055.81 520.569 1093.72 520.569C1131.62 520.569 1131.62 506 1169.51 506C1207.39 506 1207.39 520.569 1245.3 520.569C1283.2 520.569 1283.18 506 1321.07 506C1358.95 506 1358.95 520.569 1396.86 520.569C1419.27 520.569 1428.43 515.47 1440 511.318Z",
    fill: "#65A4F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2200_33161)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M592.284 703.608C601.915 699.641 606.512 688.602 602.552 678.953C598.593 669.303 587.575 664.697 577.944 668.664C568.313 672.631 563.716 683.67 567.676 693.32C571.635 702.97 582.653 707.576 592.284 703.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1251.08 809.034C1260.71 805.067 1265.31 794.028 1261.35 784.378C1257.39 774.729 1246.37 770.122 1236.74 774.09C1227.11 778.057 1222.51 789.096 1226.47 798.746C1230.43 808.395 1241.45 813.002 1251.08 809.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1027.08 875.797C1040.91 875.797 1052.12 864.565 1052.12 850.709C1052.12 836.853 1040.91 825.621 1027.08 825.621C1013.25 825.621 1002.04 836.853 1002.04 850.709C1002.04 864.565 1013.25 875.797 1027.08 875.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.04 858.145C170.869 858.145 182.079 846.913 182.079 833.057C182.079 819.201 170.869 807.969 157.04 807.969C143.211 807.969 132 819.201 132 833.057C132 846.913 143.211 858.145 157.04 858.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M509.627 900C516.78 900 522.579 894.19 522.579 887.022C522.579 879.855 516.78 874.044 509.627 874.044C502.473 874.044 496.674 879.855 496.674 887.022C496.674 894.19 502.473 900 509.627 900Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.992 613.956C177.145 613.956 182.945 608.145 182.945 600.978C182.945 593.81 177.145 588 169.992 588C162.838 588 157.039 593.81 157.039 600.978C157.039 608.145 162.838 613.956 169.992 613.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M873.205 692.62C880.193 692.62 885.857 686.944 885.857 679.943C885.857 672.942 880.193 667.266 873.205 667.266C866.217 667.266 860.553 672.942 860.553 679.943C860.553 686.944 866.217 692.62 873.205 692.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M387.715 760.059C387.715 767.052 382.042 772.735 375.062 772.735C368.083 772.735 362.41 767.07 362.41 760.059C362.41 753.047 368.083 747.382 375.062 747.382C382.042 747.382 387.715 753.047 387.715 760.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1333 600.978C1333 607.971 1327.33 613.655 1320.35 613.655C1313.37 613.655 1307.7 607.989 1307.7 600.978C1307.7 593.967 1313.37 588.301 1320.35 588.301C1327.33 588.301 1333 593.967 1333 600.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1031.85 726.224C1041.54 726.224 1049.4 718.353 1049.4 708.643C1049.4 698.933 1041.54 691.062 1031.85 691.062C1022.16 691.062 1014.31 698.933 1014.31 708.643C1014.31 718.353 1022.16 726.224 1031.85 726.224Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2200_33161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382 321.382C382 305.262 368.865 292.179 352.681 292.179C346.818 292.179 341.397 293.918 336.81 296.852C331.676 279.59 315.623 267 296.624 267C273.456 267 254.666 285.716 254.666 308.792C254.666 309 254.692 309.208 254.692 309.415H254.666C243.252 309.415 234 318.63 234 330H380.697C381.531 327.274 382 324.367 382 321.382Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2200_33161",
    x1: 719.016,
    y1: 441.424,
    x2: 742.864,
    y2: 553.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9D6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BFCEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AFC0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99ADCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2200_33161",
    x1: 683.398,
    y1: 475.843,
    x2: 745.381,
    y2: 617.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CBD8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C1D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B1C2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9BAFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E96B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2200_33161",
    x1: 448.305,
    y1: 484.416,
    x2: 482.643,
    y2: 490.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9D6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BFCEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AFC0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99ADCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2200_33161",
    x1: 403,
    y1: 561.21,
    x2: 512.234,
    y2: 561.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2200_33161",
    x1: 558.854,
    y1: 452.981,
    x2: 531.828,
    y2: 553.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9D6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BFCEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AFC0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99ADCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2200_33161",
    x1: 458.877,
    y1: 606.727,
    x2: 545.982,
    y2: 606.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2200_33161",
    x1: 538.864,
    y1: 559.336,
    x2: 511.842,
    y2: 636.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9D6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BFCEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AFC0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99ADCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2200_33161",
    x1: 508.762,
    y1: 575.181,
    x2: 570.218,
    y2: 575.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2200_33161",
    x1: 524.947,
    y1: 556.32,
    x2: 579.176,
    y2: 556.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E0EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2200_33161",
    x1: 984.881,
    y1: 528.441,
    x2: 1038,
    y2: 528.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E0EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2200_33161",
    x1: 928.783,
    y1: 588.691,
    x2: 968.064,
    y2: 588.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2200_33161",
    x1: 909.459,
    y1: 538.332,
    x2: 972.834,
    y2: 538.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E0EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2200_33161",
    x1: 937.881,
    y1: 508.342,
    x2: 980.252,
    y2: 508.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2200_33161",
    x1: 861.207,
    y1: 567.37,
    x2: 900.186,
    y2: 567.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A7B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9DB0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8DA3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2200_33161",
    x1: 940.512,
    y1: 419.086,
    x2: 1035.05,
    y2: 419.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E0EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2200_33161",
    x1: 946.551,
    y1: 445.694,
    x2: 889.358,
    y2: 537.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9D6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BFCEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AFC0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99ADCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D95B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 982,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 107,
    fill: "white",
    transform: "translate(-80 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 115,
    fill: "white",
    transform: "translate(1115 74)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 635,
    height: 237,
    fill: "white",
    transform: "translate(403 387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 476,
    fill: "white",
    transform: "translate(0 506)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1201,
    height: 312,
    fill: "white",
    transform: "translate(132 588)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2200_33161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 63,
    fill: "white",
    transform: "translate(234 267)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.32adca300deeb5effc14c533374cb5f1.svg";
export { ForwardRef as ReactComponent };